module.exports = __webpack_public_path__ + "img/gold.c46edfc3.png";